// knobs.ts
export const KNOBS = {
  scene: {
    background: "#0b0f14",
    dpr: [1, 1.75] as [number, number],
    antialias: true,
    toneMapping: "NoToneMapping" as const,
    camera: { position: [0, 18, 42] as [number, number, number], fov: 50, near: 0.1, far: 2000 },
    lights: {
      ambient: 0.35,                              // ambientLight intensity
      corePointLight: { pos: [0, 0, 0] as [number, number, number], intensity: 1.6 }
    }
  },

  coreBall: {
    radius: 4,                                     // sphere radius
    centerY: 6,                                    // vertical offset of the ball center
    spinY: 0.5,                                    // radians/sec (approx) yaw spin
    spinX: 0.5 * 0.36,                             // subtle extra tilt spin
    dimples: { count: 28, holeRadiusCoeff: 0.085 },// radius * coeff = hole radius
    material: {
      baseHex: "#D6E24A",
      emissiveHex: "#E8F766",
      emissiveIntensity: 0.18,
      roughness: 0.6,                              // only used by SafeBall; RealPickleballCore has its own
      metalness: 0.0,
      backfaceDarken: 0.45,                        // RealPickleballCore interior darkening
      ambient: 0.25
    }
  },

  ringAndPanels: {
    orbitRadius: 18.5,                             // ring radius for category panels
    orbitY: -3.8,                                  // vertical offset of the ring
    autoRotateSpeed: 0.08,                         // rad/sec for the ring group
    panelAnchorOffsetY: 2.12,                      // where bezier curves start above each panel root
    tableOverlay: {
      widthPx: 440,                                // PlanetTableOverlay width
      distanceFactor: 10,                          // overlay size attenuation by camera distance
      orientOutwardFrom: [0, 0, 0] as [number, number, number]
    },
    title: {
      text: "Pickleball Skills",
      fontSize: 1.8,
      yOffsetOverCore: 2.0                         // how far above the ball surface to place the title
    }
  },

  curves: {
    lift: 4,                                     // base height of quadratic control point
    samples: 48,                                   // segments per curve (performance vs smoothness)
    line: {
      width: 2.6,                                  // Line lineWidth (requires WebGL2 + platform support)
      baseOpacity: 0.55,                           // average opacity; modulated by ‘pulse’
      pulseSpeed: 1.2,                             // Hz-ish pulse speed
      pulsePhaseStep: 0.9                          // phase offset per curve index
      // dashed: false, dashScale: 2.4, dashSize: 0.22, gapSize: 0.16
    },
    jitter: {
      wanderDegA: 18,                              // larger wander amplitude (deg)
      wanderDegB: 10,                              // smaller wander amplitude (deg)
      precessionDeg: 8,                            // slow rotation around base normal (deg)
      speedA: 0.18,                                // scales base speed per emitter
      speedB: 0.11,                                // secondary speed scale
      extraLiftAmp: 0.35,                          // extra vertical wobble added to control point
      extraLiftFreqScale: 0.9                      // frequency scaling for the lift wobble
    }
  },

  travellers: {
    speed: 0.03, // 0.15,                                    // progress/sec along the curve (0..1 wraps)
    ridersPerEmitter: 1, // 2,                           // how many labels/dots per emitter/category

    // label sizing: target CSS-pixel height converted to world units
    cardPixels: { target: 80, max: 120 },          // desired on-screen height (px), and hard screen cap
    worldScaleClamp: { min: 0.14, max: 1.10 },     // final world scale clamps after conversion
    shrinkAlongCurve: { startT: 0.2, endT: 0.8 },  // shrink window as rider approaches the core

    // visibility / occlusion
    frontCullEpsilon: 0.02,                        // > 0 → front hemisphere, <= back → hidden
    frontFadeWindow: { startDot: 0.02, endDot: 0.55 }, // fade near horizon on the FRONT only

    // card geometry & text layout (TroikaText-backed)
    cardFrame: {
      paddingX: 0.40,
      paddingY: 0.30,
      minW: 1.10,
      minH: 0.58,
      borderExtra: 0.08,
      scale: 1.0,
      text: {
        fontSize: 0.1, //0.18,            // world units (pre-scaling)
        lineHeight: 1.08,
        color: "#0b1a3a",
        maxWidth: 5.0,             // wrap width in world units (before auto-scaling)
        outlineWidth: 0
      },
      colors: {
        border: "#203040",
        fill: "#f6f8fb"
      },
      opacities: {
        border: 0.95,
        fill: 0.95
      }
    }
  }
} as const;
